import React, { useState, useCallback } from 'react';
import PropTypes from 'prop-types';
// CON-7886: Will be re-enabled when infinite loop issue is resolved
// import { searchClient } from 'components/essentials/AlgoliaSearchClient';
// import { ALGOLIA_INDEX_NAME } from 'commons/constants';
import MobileOnly from 'components/consumer/MobileOnly';
import ShopByTitleNavigation from 'components/consumer/ShopByTitleNavigation';
import ShopByMobileFiltersBar from 'components/consumer/ShopByMobileFiltersBar';
import MobileFiltersButton from 'components/consumer/MobileFiltersButton';
import MobileModal from 'components/consumer/MobileModal';
import ClearAllFiltersButton from 'components/consumer/ClearAllFiltersButton';
import CtaButton from 'components/essentials/Cta/CtaButton';
import IconMobileGrid1x from 'components/icons/iconMobileGrid1x';
import IconMobileGrid2x from 'components/icons/iconMobileGrid2x';
import IconMobileGrid3x from 'components/icons/iconMobileGrid3x';
// CON-7886: Will be re-enabled when infinite loop issue is resolved
// import { InstantSearch, Configure } from 'react-instantsearch';
import CustomerNameWithEmoji from 'components/consumer/CustomerNameWithEmoji';
import useFilters from '../hooks/useFilters';
import GridWithSidebar from '../../GridWithSidebar';
import {
  // CON-7886: Will be re-enabled when infinite loop issue is resolved
  // InspirationSearchBox,
  // InspirationSearchOptions,
  transformInspirationImageUrl,
} from '../search-state/utils';
import InspirationFiltersTop from '../inspiration-filters/InspirationFiltersTop';
import CustomerPhotosGrid from '../components/CustomerPhotosGrid';
import useUrlPhotoSelection from '../hooks/useUrlPhotoSelection';
import useProductFilterState from '../hooks/useProductFilterState';
import useProductSearch from '../hooks/useProductSearch';
import useCustomerPhotosFilterActions from '../hooks/useCustomerPhotosFilterActions';

const MobileInspirationPage = React.memo(
  // CON-7886: Commented-out item will be re-enabled when infinite loop issue is resolved
  ({ mobileItemsPerRow, /* fabricsData, */ toggleMobileItemsPerRow }) => {
    const [selectedPhoto, setSelectedPhoto] = useState(null);
    const { state: filterState, actions: filterActions } = useFilters();

    const { handlePhotosLoaded } = useUrlPhotoSelection(setSelectedPhoto);

    // CON-7886: Will be re-enabled when infinite loop issue is resolved
    /*
    const {
      // productSearchState,
      onSearchUpdate,
      resetProductSearch,
      handleProductClicked,
      handleMaterialOptionChange,
    } = */

    useProductSearch(filterState, filterActions);

    const getCustomProps = useCallback(selectedItem => {
      if (!selectedItem) return {};

      const customerName =
        selectedItem.customer_last_name &&
        selectedItem.customer_last_name.length > 0
          ? `${selectedItem.customer_first_name} ${selectedItem.customer_last_name[0]}.`
          : selectedItem.customer_first_name || '';

      const products = selectedItem.products || [];
      return {
        imageProps: {
          src: transformInspirationImageUrl(selectedItem.image_link),
          trim: 'auto',
        },
        selectedItemName: (
          <CustomerNameWithEmoji>{customerName}</CustomerNameWithEmoji>
        ),
        selectedItemNameMobile: (
          <span className="CustomerPhotosCustomerNameMobile">
            {customerName}
          </span>
        ),
        selectedItemProducts: products,
        selectedItemMaterialList: products.map(p => p.upholstery),
        selectedItemDescription: selectedItem.photo_comment || '',
        showDescriptionQuoteMark: true,
        onProductCardClick: () => {
          // Mobile doesn't need browser storage logic
        },
      };
    }, []);

    const customerPhotosFilterActions = useCustomerPhotosFilterActions(
      filterState,
      filterActions
    );

    // CON-7886: Will be re-enabled when infinite loop issue is resolved
    // const { isProductIdFiltered } =

    useProductFilterState(filterState.selectedProduct);

    const { numberOfActiveFilters } = filterState;
    const mobileModalTitle =
      numberOfActiveFilters > 0
        ? `Filters (${numberOfActiveFilters})`
        : 'Filters';

    return (
      <div className="customer-photos__container relative">
        <MobileOnly>
          <div className="md:hidden">
            <MobileModal
              title={mobileModalTitle}
              onClose={filterActions.closeMobileFilters}
              isOpen={!!filterState.isMobileFiltersOpen}
              isFullHeight
              headerRight={
                !!filterState.isFiltered && (
                  <div className="-ml-4 -mr-4 pl-4 pr-4 -mb-2.5 md:bg-white md:h-10 md:pb-3">
                    <ClearAllFiltersButton
                      onClick={filterActions.clearAllFilters}
                      variant="ShopByMobile"
                    >
                      Clear all
                    </ClearAllFiltersButton>
                  </div>
                )
              }
              stickyFooter={
                <CtaButton block onClick={filterActions.closeMobileFilters}>
                  Done
                </CtaButton>
              }
              className="MobileFiltersModal"
              closeIcon="arrow"
            >
              <InspirationFiltersTop
                filterState={filterState}
                filterActions={customerPhotosFilterActions}
              />
            </MobileModal>
          </div>

          <div className="md:hidden">
            <ShopByTitleNavigation page="Inspiration" />
          </div>

          <ShopByMobileFiltersBar className="gap-4">
            <MobileFiltersButton
              onClick={filterActions.openMobileFilters}
              numberOfActiveFilters={numberOfActiveFilters}
              noMargin
            />

            <div className="relative">
              {/* CON-7886: Temporarily disabled due to infinite loop, will be fixed and re-enabled in that ticket */}
              {/* v7 compatible - removed deprecated searchState/onSearchStateChange props */}
              {/* <InstantSearch
                searchClient={searchClient}
                indexName={ALGOLIA_INDEX_NAME.PRODUCTS}
              >
                <Configure hitsPerPage="24" query={filterState.searchQuery} />
                <InspirationSearchBox
                  resetProductSearch={resetProductSearch}
                  onProductClicked={handleProductClicked}
                />
                <InspirationSearchOptions
                  fabricsData={fabricsData}
                  onSearchUpdate={onSearchUpdate}
                  onMaterialOptionChange={handleMaterialOptionChange}
                  onProductClicked={handleProductClicked}
                  isProductIdFiltered={isProductIdFiltered}
                  isMaterialOptionFiltered={filterState.searchMaterialFilter}
                />
              </InstantSearch> */}
            </div>

            <span className="items-center flex flex-1 justify-end">
              <button
                className="bg-none items-center bg-white border-0 flex justify-center ml-[3px] focus-visible:outline-offset-4"
                onClick={toggleMobileItemsPerRow}
                type="button"
              >
                {mobileItemsPerRow === 1 ? (
                  <IconMobileGrid1x />
                ) : mobileItemsPerRow === 2 ? (
                  <IconMobileGrid2x />
                ) : (
                  <IconMobileGrid3x />
                )}
              </button>
            </span>
          </ShopByMobileFiltersBar>

          <div className="md:hidden">
            <div className="inspiration-page [&_.infinite-scroll-component]:!m-0 relative">
              <CustomerPhotosGrid
                mobileItemsPerRow={mobileItemsPerRow}
                updateSelectedGridItem={setSelectedPhoto}
                variant="InspirationPage"
                onPhotoFound={handlePhotosLoaded}
                filterState={filterState}
                filterActions={filterActions}
              />
              {selectedPhoto && (
                <GridWithSidebar
                  getCustomProps={getCustomProps}
                  gridItemType="customer-photo"
                  mobileItemsPerRow={mobileItemsPerRow}
                  naturalHeightImages
                  renderGrid={() => null}
                  tabsConfig={{
                    products: true,
                    productsTitle: ' ',
                    productsHideLoadMore: true,
                  }}
                  variant="InspirationPage"
                  initialSelection={selectedPhoto}
                  onClose={() => setSelectedPhoto(null)}
                />
              )}
            </div>
          </div>
        </MobileOnly>
      </div>
    );
  }
);

MobileInspirationPage.propTypes = {
  mobileItemsPerRow: PropTypes.number.isRequired,
  toggleMobileItemsPerRow: PropTypes.func.isRequired,
  // CON-7886: Will be re-enabled when infinite loop issue is resolved
  // fabricsData: PropTypes.array,
};

export default MobileInspirationPage;
